// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { useTranslation } from 'react-i18next';
// images
import iconCalendar from '../../../sass/images/business/icon-calendar-day.svg';

function DashboardNotPlan({ company }) {
  const [t] = useTranslation(['dahsboard', 'alert', 'alt', 'routers'], { useSuspense: false });

  return (
    <>
      <div className="content_dynamic history company-block business">
        <Row className="content_history">
          <div className="header-content">
            <div className="info-tittle">
              <h1 className="title-maintenances">Dashboard</h1>
              <h3>
                <strong>
                  {t('welcome')} {company}.
                </strong>
              </h3>
            </div>
          </div>
          <div className="convention-services">
            <div className="type-status">
              <>
                <h3>
                  <strong>{t('tittle2')}</strong>
                </h3>
                <p>{t('graphic-1')}</p>
              </>
            </div>
          </div>
        </Row>
        <Row className="graphics no-gutters">
          <Col xl={6} lg={12} md={12} sm={4}>
            <Card className="block1">
              <Card.Body>
                <Row className="no-gutters">
                  <Col lg={5} xs={6} className="text_line">
                    <Card.Title className="data-title"> - - </Card.Title>
                    <Card.Subtitle className="not_plan_content">
                      {t('requests_made')}
                      <p>{t('graphic-2')}</p>
                    </Card.Subtitle>
                  </Col>
                  <Col lg={5} xs={6} className="text_line">
                    <Card.Title className="data-title"> - - </Card.Title>
                    <Card.Subtitle className="not_plan_content">
                      {t('maintenance_performed')}
                      <p>{t('graphic-3')}</p>
                    </Card.Subtitle>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
          <Col xl={3} lg={6} md={6} sm={4}>
            <Card className="block2">
              <Card.Body>
                <Card.Title className="data-title"> - -/- -/- - - - </Card.Title>
                <Card.Subtitle className="not_plan_content">
                  {t('next_maintenance')}
                  <p>{t('graphic-4')}</p>
                </Card.Subtitle>
              </Card.Body>
            </Card>
          </Col>
          <Col xl={3} lg={6} md={6} sm={4}>
            <Card className="block3 card-last-child">
              <Card.Body>
                <Card.Title>
                  <img alt="" src={iconCalendar} />
                </Card.Title>
                <Card.Subtitle className="not_plan_content">
                  {t('dates_available_maintenance')}
                  <p>{t('graphic-5')}</p>
                </Card.Subtitle>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="graphics no-gutters">
          <Col xl={4} lg={12} md={12} sm={4}>
            <Card>
              <Card.Body>
                <Card.Title>{t('tittle2')}</Card.Title>
                <Card.Subtitle className="not_plan">{t('graphic-6')}</Card.Subtitle>
              </Card.Body>
            </Card>
          </Col>
          <Col xl={8} lg={12} md={12} sm={8}>
            <Card className="card-last-child">
              <Card.Body>
                <Card.Title> {t('maintenance_system')} </Card.Title>
                <Card.Subtitle className="not_plan">{t('graphic-7')}</Card.Subtitle>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="graphics no-gutters">
          <Col xl={6} lg={12} md={12} sm={6}>
            <Card>
              <Card.Body>
                <Card.Title> {t('vehicle_health')} </Card.Title>
                <Card.Subtitle className="not_plan">{t('graphic-8')}</Card.Subtitle>
              </Card.Body>
            </Card>
          </Col>
          <Col xl={6} lg={12} md={12} sm={6}>
            <Card className="card-last-child">
              <Card.Body>
                <Card.Title> {t('fleet_jobs_forecast')} </Card.Title>
                <Card.Subtitle className="not_plan">{t('graphic-9')}</Card.Subtitle>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="graphics no-gutters">
          <Col xl={12} lg={12} md={12} sm={12}>
            <Card>
              <Card.Body>
                <Card.Title> {t('location_vehicle')} </Card.Title>
                <Card.Subtitle className="not_plan">{t('graphic-10')}</Card.Subtitle>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

DashboardNotPlan.propTypes = {
  company: PropTypes.string,
};
DashboardNotPlan.defaultProps = {
  company: '',
};
export default DashboardNotPlan;
